module.exports = __webpack_public_path__ + "assets/img/thumb-NuMobile-Brand-Video.2f48419c.jpg";